import { apiJson, apiJsonArray } from '@/lib/api-client';

export class BookingService {
  static async getAllBookings(): Promise<any[]> {
    return apiJsonArray<any>('api/bookings/admin/all');
  }

  static async getBookingById(bookingId: number): Promise<any | null> {
    return apiJson<any | null>(`api/bookings/${bookingId}`);
  }

  static async hasConfirmedBookings(periodId: number): Promise<boolean> {
    const r = await apiJson<{ value: boolean }>(
      `api/bookings/period/${periodId}/has-confirmed`,
    );
    return r.value;
  }

  static async hasAnyBookings(periodId: number): Promise<boolean> {
    const r = await apiJson<{ value: boolean }>(
      `api/bookings/period/${periodId}/has-any`,
    );
    return r.value;
  }

  static async getPeriodBookings(periodId: number): Promise<any[]> {
    return apiJsonArray<any>(`api/bookings/period/${periodId}/list`);
  }

  static async hasPendingBookingForPeriod(
    guestId: number,
    periodId: number,
  ): Promise<boolean> {
    const r = await apiJson<{ value: boolean }>(
      `api/bookings/check/pending-period?guestId=${guestId}&periodId=${periodId}`,
    );
    return r.value;
  }

  static async hasAnyBookingForPeriod(
    guestId: number,
    periodId: number,
  ): Promise<boolean> {
    const r = await apiJson<{ value: boolean }>(
      `api/bookings/check/any-period?guestId=${guestId}&periodId=${periodId}`,
    );
    return r.value;
  }

  static async getBookingRequestsByGuest(guestId: number): Promise<any[]> {
    return apiJsonArray<any>(`api/bookings/guest/${guestId}`);
  }

  static async createBookingRequest(bookingData: any): Promise<any> {
    return apiJson('api/bookings', {
      method: 'POST',
      body: JSON.stringify(bookingData),
    });
  }

  static async cancelBookingRequest(
    bookingId: number,
    reason: string,
  ): Promise<boolean> {
    await apiJson(`api/bookings/${bookingId}/cancel`, {
      method: 'POST',
      body: JSON.stringify({ reason }),
    });
    return true;
  }

  static async getBookingRequestsByOwner(ownerId: number): Promise<any[]> {
    return apiJsonArray<any>(`api/bookings/owner/${ownerId}`);
  }

  static async rejectBookingRequest(bookingId: number): Promise<boolean> {
    await apiJson(`api/bookings/${bookingId}/reject`, { method: 'POST' });
    return true;
  }

  static async approveBookingRequest(
    bookingId: number,
    discountAmount?: number,
    ownerComment?: string,
  ): Promise<void> {
    await apiJson(`api/bookings/${bookingId}/approve`, {
      method: 'POST',
      body: JSON.stringify({ discountAmount, ownerComment }),
    });
  }

  static async rejectBookingRequestWithNotifications(
    bookingId: number,
    reason?: string,
  ): Promise<void> {
    await apiJson(`api/bookings/${bookingId}/reject-detailed`, {
      method: 'POST',
      body: JSON.stringify({ reason }),
    });
  }

  static async deleteBooking(bookingId: number): Promise<void> {
    await apiJson(`api/bookings/admin/${bookingId}`, { method: 'DELETE' });
  }
}
